export default __webpack_public_path__ + "static/media/gallery_04.eaa59ed5.jpg";